import { render } from "./MFAValidate.vue?vue&type=template&id=2b678ce2"
import script from "./MFAValidate.vue?vue&type=script&lang=js"
export * from "./MFAValidate.vue?vue&type=script&lang=js"
script.render = render

export default script